/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectionerror1Inputs */



/**
* | output |
* | --- |
* | "Connection error" |
*
* @param {Connectionerror1Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const connectionerror1 = /** @type {((inputs?: Connectionerror1Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectionerror1Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Connection error")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de conexión")
	return /** @type {LocalizedString} */ ("Ошибка соединения")
});
export { connectionerror1 as "connectionError" }